import React from 'react';
import { EmploymentField } from '@composite/employments/employment-field';

export function EmploymentFields() {
  return <EmploymentField display="IN_AUDITOR" disabled />;
}
